/**
 * DoorDash Integrations API
 *
 * This file provides re-exports for DoorDash API hooks and operations
 */

export { default as integrationsAPI } from '~/api/DoorDashApi/DoorDashApi';

export { useGenerateQuoteMutation } from './hooks/useGenerateQuoteMutation';
export { useAcceptQuoteMutation } from './hooks/useAcceptQuoteMutation';
export { useSaveDoorDashConfig } from './hooks/useSaveDoorDashConfig';
export { useGenerateMultiCarrierQuoteMutation } from './hooks/useGenerateMultiCarrierQuoteMutation';

/**
 * Placeholder for RTK Query API object
 * This is needed for tests that reference integrationsApi.reducer
 * TODO: Remove once tests are updated
 */
export const integrationsApi = {
    reducerPath: 'integrationsApi',
    reducer: (state = {}) => state,
    middleware: (getDefaultMiddleware: (options?: unknown) => unknown[]) =>
        getDefaultMiddleware()
};
